<template>
  <v-dialog
      v-model="showQq"
      persistent
      width="600"
  >
    <v-card
        v-if="loading"
        class="pa-4"
    >
      <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
      ></v-progress-linear>
    </v-card>
    <v-card
        v-else
        class="pa-6"
    >
        <button
                @click="close"
                class="qa-close mb-6"
        >
          ✖
        </button>
      <div class="mt-4">
        <template v-for="(question, indx) in questions">
          <div class="d-flex justify-content-between" :key="'q-' + indx">
            <div class="q-list">
              {{ question.question }}
            </div>
            <div>
              <v-chip-group
                  v-model="question.answer"
                  class="mx-auto revers-chips"
                  group
                  color="black"
                  active-class="w-border"
                  :class="question.answer != null ? 'all-grey' : ''"
              >
                <template v-for="(answer, i) in question.answers">
                  <v-chip
                      :key="i"
                      :value="i"
                      :color="btnClr(i)"
                      small
                  >
                    {{ answer }}
                  </v-chip>
                </template>
              </v-chip-group>
            </div>
          </div>
        </template>
      </div>
      <v-card-actions>
        <v-btn
            @click="sendAndNext"
            class="mx-auto"
            :disabled="noAllChecked"
        >
          Далее
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'questionnaire',
  props: ['showQq'],
  data() {
    return {
      questions: [
        {
          question: 'Кузов чистый и без потеков?',
          answers: ['Да','Нет'],
          answer: null
        },
        {
          question: 'Дверные проемы чистые?',
          answers: ['Да','Нет'],
          answer: null
        },
        {
          question: 'Стекла чистые и без разводов?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null

        },
        {
          question: 'В салоне чисто?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Торпедо без пыли?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Экран(ы) без разводов?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Пепельница(ы) очищены?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Весь мусор убран из салона/дверей?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Коврики чистые?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Багажник убран?',
          answers: ['Да','Нет','Не входит в заказ'],
          answer: null
        },
        {
          question: 'Колеса чистые?',
          answers: ['Да','Нет'],
          answer: null
        },
      ],
      loading: false,
    }
  },
  computed: {
    noAllChecked () {
      let notAllChecked = false
      this.questions.forEach((q) => {
        if (q.answer === null) {
          notAllChecked = true
        }
      })
      return notAllChecked
    },
  },
  watch: {
    showQq (newVal) {
      if (newVal) {
        this.questions.forEach((question) => {
          question.answer = null
        })
      }
      // if (newVal) {
      //   console.log(this.qtype)
      //   const questType = this.qtype
      //   this.$store.dispatch('questionnaire/getQuestions', questType).then((resp) => {
      //     if (resp.data.questions && resp.data.questions.length > 0) {
      //       resp.data.questions.forEach((q)=> { q.answer = null })
      //       this.questions = resp.data.questions
      //       this.loading = false
      //     } else {
      //       this.$emit('submit', null)
      //     }
      //   }).catch((e) => {
      //     console.log('Error', e)
      //   })
      // }
    },
  },
  methods: {
    btnClr(indx) {
      const colors = ['#a2f3a2', '#e18e8b', '#e2e868']
      return colors[indx]
    },
    close() {
      this.$emit('close')
    },
    submit() {
      // this.$emit('submit', () => this.$store.dispatch('questionnaire/sendAnswers', [this.qtype, this.questions]))
    },
    sendAndNext () {
      this.$emit('closeAndNext', this.questions)
      // this.$store.dispatch('questionnaire/sendAnswers', [this.type, this.questions]).then(() => {
      //
      // })
    }
  }
}
</script>
<style>
  .revers-chips .v-slide-group__content {
    display: inline-flex;
    flex-direction: row-reverse;
  }
  .all-grey span.v-chip:not(.w-border){
    opacity: 20%;
  }
  .revers-chips .v-chip {
    border-radius: 6px;
  }
  .q-list {
    font-size: larger;
  }
  .w-border {
    box-shadow:0px 0px 0px 2px #000a51 inset;
  }
  .qa-close {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
  }
</style>
